import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/shared/models/security/user';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Employee } from 'src/app/shared/models/employee/employee';
import { LogService } from 'src/app/core/services/log/log.service';
import { EmployeeTypeString } from 'src/app/shared/models/employee/employee-type';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';

@Component({
	selector: 'app-user-infos',
	templateUrl: './user-infos.component.html',
	styleUrls: ['./user-infos.component.scss']
})
export class UserInfosComponent implements OnInit {
	user: User;
	employee: Employee;
	isIntervenant: boolean;

	listUser: User[];

	employeeTypeString = EmployeeTypeString;

	constructor(private facade: FacadeService, private logger: LogService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();

		if(this.isIntervenant){
			this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
				next: (val) => {
					this.employee = val;
				}
			})
		}
	}
}
